const DISPLAY_FORMAT = 'dd/MM/yyyy';
const DATE_PICKER_FORMAT = DISPLAY_FORMAT;

function pad2(value) {
  return String(value).padStart(2, '0');
}

export function parseDate(isoDateOnly) {
  if (!isoDateOnly) {
    return null;
  }
  const raw = String(isoDateOnly).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
    const [y, m, d] = raw.split('-').map(Number);
    return new Date(y, m - 1, d);
  }
  const match = raw.match(/^(\d{4}-\d{2}-\d{2})/);
  if (match) {
    const [y, m, d] = match[1].split('-').map(Number);
    return new Date(y, m - 1, d);
  }
  return null;
}

export function deserializeDateOnly(isoDateOnly) {
  return parseDate(isoDateOnly);
}

export function serializeDateOnly(calendarDate) {
  if (!calendarDate) {
    return '';
  }
  if (typeof calendarDate === 'string') {
    return serializeDateOnly(parseDate(calendarDate));
  }
  const y = calendarDate.getFullYear();
  const m = pad2(calendarDate.getMonth() + 1);
  const d = pad2(calendarDate.getDate());
  return `${y}-${m}-${d}`;
}

export function serializeDateForApi(value) {
  if (!value) {
    return '';
  }
  if (typeof value === 'string') {
    return serializeDateOnly(parseDate(value));
  }
  return serializeDateOnly(value);
}

export function formatDate(calendarDate) {
  return displayDate(calendarDate);
}

export function displayDate(value) {
  const calendarDate = typeof value === 'string' ? parseDate(value) : value;
  if (!calendarDate) {
    return '';
  }
  const day = pad2(calendarDate.getDate());
  const month = pad2(calendarDate.getMonth() + 1);
  const year = calendarDate.getFullYear();
  return `${day}/${month}/${year}`;
}

export function displayDateTime(value) {
  const date = typeof value === 'string' ? parseDate(value) : value;
  if (!date) {
    return '';
  }
  const hours = pad2(date.getHours());
  const minutes = pad2(date.getMinutes());
  return `${displayDate(date)} ${hours}:${minutes}`;
}

export function compareCalendarDates(left, right) {
  const a = serializeDateOnly(left);
  const b = serializeDateOnly(right);
  if (a === b) {
    return 0;
  }
  return a < b ? -1 : 1;
}

export function isCalendarDateBefore(left, right) {
  return compareCalendarDates(left, right) < 0;
}

export function isCalendarDateAfter(left, right) {
  return compareCalendarDates(left, right) > 0;
}

export function isCalendarDateOnOrBefore(left, right) {
  return compareCalendarDates(left, right) <= 0;
}

export function isCalendarDateOnOrAfter(left, right) {
  return compareCalendarDates(left, right) >= 0;
}

export function todayCalendarDate() {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate());
}

export { DISPLAY_FORMAT, DATE_PICKER_FORMAT };
